import React from 'react';
import 'fontsource-roboto';
import {makeStyles} from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import WarningRoundedIcon from '@material-ui/icons/WarningRounded';

const useStyles = makeStyles(theme => ({
  icon: {
    marginRight: theme.spacing(.5)
  }
}));

export default function Warning(props) {
  const classes = useStyles();

  return (
    <Typography {...props} style={props.style}>
      <WarningRoundedIcon className={classes.icon} />
      {props.children}
    </Typography>
  );
}

Warning.defaultProps = {
  variant: 'caption',
  color: 'error'
};